import CheckboxComponent from './Checkbox';

export default CheckboxComponent;
